<section [@fadeInDown]>
  <app-back-button></app-back-button>
  <div class="base-container">
    <app-verification-info [status]="verifySuccess"></app-verification-info>
  </div>
</section>
